/**
 * Created by jv on 2019-09-25 (10:20).
 */
require("slick-carousel/slick/slick.scss");
require("slick-carousel/slick/slick-theme.scss");

const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/game/investment-view.html";

const resourceIcons = require.context("!raw-loader!Images/business-model/resource-icons", false, /\.svg$/);
const investmentIcons = require.context("!raw-loader!Images/business-model/investments", false, /\.svg$/);

require("Styles/components/investment-card.scss");
require("Styles/components/investment-slider.scss");

const investmentData = {
    microchip_factory: {
        image: "microchip_factory.svg",
        imagePopup: "info_microchip_factory.svg",
        market: { price: 2, image: "microchip.svg" }
    },
    phone_factory: {
        image: "mobile_phone_factory.svg",
        imagePopup: "info_mobile_phone_factory.svg",
        market: { price: 5, image: "mobile phone.svg" }
    },
    bike_factory: {
        image: "ebike_factory.svg",
        imagePopup: "info_bike_factory.svg",
        market: { price: 7, image: "bike.svg" }
    },
    microchip_efficiency: { image: "efficiency_microchip.svg", imagePopup: "info_resource_efficiency_microchip.svg" },
    microchip_substitution: {
        image: "substitution_microchip.svg",
        imagePopup: "info_resource_substitution_microchip.svg"
    },
    phone_efficiency: { image: "efficiency_mobile.svg", imagePopup: "info_resource_efficiency_mobile.svg" },
    phone_substitution: { image: "substitution_mobile.svg", imagePopup: "info_resource_substitution_mobile.svg" },
    bike_efficiency: { image: "efficiency_bike.svg", imagePopup: "info_resource_efficiency_bike.svg" },
    bike_substitution: { image: "substitution_bike.svg", imagePopup: "info_resource_substitution_bike.svg" },
    waste_recycling: { image: "waste_recycling.svg", imagePopup: "info_waste_recycling.svg" },
    microchip_reuse: { image: "microchip_reuse_facility.svg", imagePopup: "info_microchip_reuse_facility.svg" },
    product_refurbishing: {
        image: "product_refurbishing_facility.svg",
        imagePopup: "info_product_refurbishing_facility.svg"
    },
    rental_maintenance: { image: "rental_maintenance_service.svg", imagePopup: "info_rental_maintenance_service.svg" },
    repair_workshop: {
        image: "repair_workshop.svg",
        imagePopup: "info_repair_workshop.svg",
        upgradeText: "investment.repair_workshop.text"
    },
    hire_employee: { image: "hire_employee.svg", imagePopup: "info_hire_employee.svg" }
};

class InvestmentsView
{
    constructor(options)
    {
        this.$container = $(options.container);
        this.$element = null;

        this.hasRendered = false;
        if (InvestmentsView.hasPurchasedInvestment(options.team, { title: "bike_factory" }))
        {
            investmentData.product_refurbishing.image = "product_refurbishing_facility_bike.svg";
            investmentData.product_refurbishing.imagePopup = "info_product_refurbishing_facility_bike.svg";

            investmentData.rental_maintenance.image = "rental_maintenance_service_bike.svg";
            investmentData.rental_maintenance.imagePopup = "info_rental_maintenance_service_bike.svg";
        }
        this.investmentData = investmentData;


        this.team = options.team;
        this._roundOverview = options.roundOverview;

        this.investments = options.investments;

        this.onInvestmentClicked = options.onInvestmentClicked;

    }

    get roundOverview()
    {
        return this._roundOverview;
    }

    set roundOverview(roundOverview)
    {
        this._roundOverview = roundOverview;

        this.updateData();
    }

    get currentRoundData()
    {
        return this.roundOverview.currentRoundData;
    }

    render()
    {
        this.hasRendered = false;

        this.$element = $(HtmlTemplate);
        this.$container.append(this.$element);
        LanguageManager.applyLocale(this.$element);

        // this.renderSlider();
        this.renderOverview();

        this.setUpEventListeners();
    }

    renderOverview()
    {
        try
        {
            // this.$container.find(".investments-container").empty();

            for (let i = 0; i < this.investments.length; ++i)
            {
                let investment = this.investments[i];

                let hardRequirements = InvestmentsView.checkHardRequirements(this.team, investment);
                let softRequirements = InvestmentsView.checkSoftRequirements(this.team, investment);
                let circular = investment.type === "circular";

                let hidden = (InvestmentsView.hasPurchasedInvestment(this.team, investment) && !investment.rebuyable) || !hardRequirements ||
                    (circular && this.currentRoundData.roundIndex < 4);
                let notAffordable = !InvestmentsView.canAffordInvestment(this.roundOverview, investment);
                let locked = notAffordable || !softRequirements ||
                    (this.currentRoundData.roundIndex < investment.minRound || this.currentRoundData.roundIndex > investment.maxRound);

                let $investmentTemplate = $("#upgrade-card-template")[0];
                let $clone = $($investmentTemplate).contents().clone();

                $clone.find(".investment-points").addClass(investment.points !== 0 ? "" : "visibility-hidden");

                $clone.find(".investment-cost label").text(investment.cost * -1);
                $clone.find(".investment-points label").text(investment.points);

                $clone.find(".upgrade-title").attr("data-localize", `investment.${investment.title}.title`);
                $clone.attr("data-investment-key", investment.key);

                let imageList = this.investmentData[investment.title];

                if (imageList !== undefined)
                {
                    if (imageList.image !== undefined)
                    {
                        let src = investmentIcons("./" + imageList.image);

                        investment.imagePopup = imageList.imagePopup;
                        investment.imageBackground = imageList.imageBackground;
                        investment.market = imageList.market;
                        investment.upgradeText = imageList.upgradeText;

                        $clone.find(".upgrade-body").html(src);
                        $clone.find(".upgrade-body svg").css({
                            "width": "100%",
                            "height": "100%"
                        });

                        if (investment.upgradeText)
                        {
                            $clone.find(".upgrade-text").attr("data-localize", investment.upgradeText);
                        }
                        else
                        {
                            $clone.find(".upgrade-text").hide();
                        }
                    }
                }

                investment.calculatedCSSClass = InvestmentsView.calculateCSSClass(investment)

                $clone.addClass(investment.calculatedCSSClass);
                $clone.addClass(hidden ? "hidden" : "");
                $clone.addClass(notAffordable ? "not-affordable" : "");
                $clone.addClass(locked ? "locked" : "");

                if (notAffordable)
                {
                    $clone.find(".investment-cost img").replaceWith(resourceIcons("./coins_red.svg"));
                }

                LanguageManager.applyLocale($clone);
                this.$container.find(".investments-container").append($clone);
            }
        }
        catch (e)
        {
            log.error(`Failed to render investment overview - ${e}`);
        }
    }

    updateData()
    {

    }

    show()
    {
        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            this.$container.show();
        }
    }

    hide()
    {
        if (utils.isNotNull(this.$container) && this.$container.length)
        {
            this.$container.hide();
        }
    }

    destroy()
    {
        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            this.$element.remove();
        }
    }

    setUpEventListeners()
    {
        this.setUpInvestmentCardClickListener();
    }

    setUpInvestmentCardClickListener()
    {
        this.$element.find(".upgrade-card:not(.locked)").off("click").on("click", (e) =>
        {
            let $this = $(e.delegateTarget);
            let investmentKey = $this.data("investment-key");

            log.info("Clicked - %s", investmentKey);

            let investment = this.getInvestmentForKey(investmentKey);

            if (utils.isNotNull(investment))
            {
                let isLocked = $this.hasClass("locked");

                if (!isLocked)
                {
                    if (utils.isFunction(this.onInvestmentClicked))
                    {
                        this.onInvestmentClicked.call(this, investment);
                    }
                }
            }
        });
    }

    static calculateCSSClass(investment)
    {
        try
        {
            switch (investment.description)
            {
                case "factory":
                    return "type-factory";
                case "waste":
                    return "type-waste";
                case "reuse":
                    return "type-reuse";
                case "rental":
                    return "type-rental";
                case "employee":
                    return "type-employee";
                default:
                    return "";
            }
        }
        catch (e)
        {
        }
        return "";
    }

    static canAffordInvestment(roundOverview, investment)
    {
        return roundOverview.currentRoundData.credits >= investment.cost;
    }

    static hasPurchasedInvestment(team, investment)
    {
        return this.purchasedInvestmentCount(team, investment) > 0;
    }

    static getPurchasedInvestment(team, investment)
    {
        return InvestmentsView.getPurchasedInvestmentByTitle(team, investment);
    }

    static checkHardRequirements(team, investment)
    {
        if (investment.title === "microchip_efficiency" && this.hasPurchasedInvestment(team, { title: "microchip_substitution" }))
        {
            return false;
        }
        if (investment.title === "microchip_substitution" && this.hasPurchasedInvestment(team, { title: "microchip_efficiency" }))
        {
            return false;
        }
        if (investment.title === "phone_efficiency" && this.hasPurchasedInvestment(team, { title: "phone_substitution" }))
        {
            return false;
        }
        if (investment.title === "phone_substitution" && this.hasPurchasedInvestment(team, { title: "phone_efficiency" }))
        {
            return false;
        }
        if (investment.title === "bike_efficiency" && this.hasPurchasedInvestment(team, { title: "bike_substitution" }))
        {
            return false;
        }
        if (investment.title === "bike_substitution" && this.hasPurchasedInvestment(team, { title: "bike_efficiency" }))
        {
            return false;
        }

        if (investment.title === "phone_factory" || investment.title === "phone_efficiency" || investment.title === "phone_substitution")
        {
            return !this.hasPurchasedInvestment(team, { title: "bike_factory" });
        }
        if (investment.title === "bike_factory" || investment.title === "bike_efficiency" || investment.title === "bike_substitution")
        {
            return !this.hasPurchasedInvestment(team, { title: "phone_factory" });
        }
        return true;
    }

    static checkSoftRequirements(team, investment)
    {
        if (investment.title === "microchip_efficiency" || investment.title === "microchip_substitution")
        {
            return this.hasPurchasedInvestment(team, { title: "microchip_factory" });
        }
        if (investment.title === "phone_efficiency" || investment.title === "phone_substitution")
        {
            return this.hasPurchasedInvestment(team, { title: "phone_factory" });
        }
        if (investment.title === "bike_efficiency" || investment.title === "bike_substitution")
        {
            return this.hasPurchasedInvestment(team, { title: "bike_factory" });
        }

        if (investment.title === "product_refurbishing")
        {
            return this.hasPurchasedInvestment(team, { title: "microchip_reuse" });
        }
        if (investment.title === "rental_maintenance")
        {
            return this.hasPurchasedInvestment(team, { title: "phone_factory" }) || this.hasPurchasedInvestment(team, { title: "bike_factory" });
        }
        if (investment.title === "repair_workshop")
        {
            return this.hasPurchasedInvestment(team, { title: "rental_maintenance" });
        }
        return true;
    }

    static purchasedInvestmentCount(team, investment)
    {
        return team.investmentData.filter(i => i.title === investment.title).length;
    }

    static getPurchasedInvestmentByTitle(team, investment)
    {
        let investments = team.investmentData.filter(i => i.title === investment.title);

        if (investments.length > 0)
        {
            investments[0].imagePopup = investmentData[investment.title].imagePopup;
            investments[0].imageBackground = investmentData[investment.title].imageBackground;
            investments[0].market = investmentData[investment.title].market;
            investments[0].upgradeText = investmentData[investment.title].upgradeText;

            return investments[0];
        }

        return null;
    }

    getInvestmentForKey(key)
    {
        if (utils.isNull(key)) return null;

        for (let i = 0; i < this.investments.length; i++)
        {
            if (this.investments[i].key === key)
            {
                return this.investments[i];
            }
        }

        return null;
    }
}

export default InvestmentsView;



// WEBPACK FOOTER //
// ./app/js/components/game/components/investments-view.js